module.exports = __webpack_public_path__ + "static/danske-mobler-5b2dc451a73aa99678d2959839208d1a.jpg";